export const VENDORS = [
  { id: 'ubiquiti',  name: 'Ubiquiti',    color: '#0559F9', bg: 'rgba(5,89,249,0.12)',   border: 'rgba(5,89,249,0.3)',   icon: 'U' },
  { id: 'amazon',    name: 'Amazon',      color: '#FF9900', bg: 'rgba(255,153,0,0.12)',  border: 'rgba(255,153,0,0.3)',  icon: 'A' },
  { id: 'homedepot', name: 'Home Depot',  color: '#F96302', bg: 'rgba(249,99,2,0.12)',   border: 'rgba(249,99,2,0.3)',   icon: 'H' },
  { id: 'bestbuy',   name: 'Best Buy',    color: '#0046BE', bg: 'rgba(0,70,190,0.12)',   border: 'rgba(0,70,190,0.3)',   icon: 'B' },
  { id: 'newegg',    name: 'Newegg',      color: '#E2231A', bg: 'rgba(226,35,26,0.12)',  border: 'rgba(226,35,26,0.3)',  icon: 'N' },
  { id: 'other',     name: 'Other',       color: '#888',    bg: 'rgba(136,136,136,0.1)', border: 'rgba(136,136,136,0.25)', icon: '•' },
];

export const vendorOf = (id) => VENDORS.find(v => v.id === id) || VENDORS[VENDORS.length - 1];

export const generateId = () => Math.random().toString(36).slice(2, 9);
